```vue
<template>
  <div class="centreSection">
    <b-container>

      <!-- CENTRE SECTION -->
      <template v-if="sec === 'centre'">
        <b-row class="align-items-center">

          <!-- CONTENT -->
          <b-col
            lg="6"
            md="12"
            order-lg="1"
            order-md="2"
            order="2"
            class="contentCol"
          >
            <div class="textSec">

              <div class="featureContent">

                <span class="eyebrow">
                  OCS Sport
                </span>

                <h3 class="featureTitle">
                  {{ acf.acf.title_2 }}
                </h3>

                <div class="titleLine"></div>

                <div
                  class="featureText"
                  v-html="acf.acf.text_2"
                ></div>

                <h4
                  v-if="acf.acf.title_2_1"
                  class="featureSubtitle"
                >
                  {{ acf.acf.title_2_1 }}
                </h4>

                <div class="featureList">

                  <div
                    v-if="acf.acf.event_bullet"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.event_bullet }}</span>
                  </div>

                  <div
                    v-if="acf.acf.event_bullet_1"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.event_bullet_1 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.event_bullet_2"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.event_bullet_2 }}</span>
                  </div>

                  <div
                    v-if="acf.acf.event_bullet_3"
                    class="featureItem"
                  >
                    <span class="featureLine"></span>
                    <span>{{ acf.acf.event_bullet_3 }}</span>
                  </div>

                </div>

              </div>

            </div>
          </b-col>


          <!-- IMAGE / VIDEO -->
          <b-col
            lg="6"
            md="12"
            order-lg="2"
            order-md="1"
            order="1"
            class="imageCol"
          >
            <div class="imageWrap">

              <div class="imageAccent"></div>

              <b-embed
                v-if="id === 158"
                type="iframe"
                aspect="16by9"
                :src="acf.acf.video_url"
                allowfullscreen
                class="featureVideo"
              ></b-embed>

              <b-img
                v-else
                :src="acf.acf.image_2"
                fluid
                class="featureImage"
              ></b-img>

            </div>
          </b-col>

        </b-row>
      </template>

    </b-container>
  </div>
</template>

<script>
export default {
  name: "rightImg",

  props: ["acf", "id", "sec"],
};
</script>

<style scoped>

/* ========================================
   SECTION
======================================== */

.centreSection {
  position: relative;
  padding: 100px 0;
  background: #ffffff;
}

::v-deep .container {
  max-width: 1400px;
  padding: 0 25px;
}


/* ========================================
   CONTENT
======================================== */

.contentCol {
  padding: 30px 50px 30px 15px;
}

.featureContent {
  max-width: 620px;
}


/* ========================================
   EYEBROW
======================================== */

.eyebrow {
  display: inline-block;
  margin-bottom: 14px;
  color: #00aeef;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}


/* ========================================
   TITLE
======================================== */

.featureTitle {
  margin: 0;
  color: #17212b;
  font-size: 42px;
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.titleLine {
  width: 55px;
  height: 3px;
  margin: 22px 0 25px;
  background: #00aeef;
}


/* ========================================
   BODY TEXT
======================================== */

.featureText {
  color: #59636d;
  font-size: 17px;
  line-height: 1.75;
  margin-bottom: 35px;
}

.featureText p {
  margin-bottom: 15px;
}


/* ========================================
   SUBTITLE
======================================== */

.featureSubtitle {
  margin: 0 0 22px;
  color: #17212b;
  font-size: 21px;
  font-weight: 500;
  line-height: 1.4;
}


/* ========================================
   FEATURES
======================================== */

.featureList {
  display: flex;
  flex-direction: column;
}

.featureItem {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 13px 0;
  border-bottom: 1px solid #e9edf0;
  color: #38434d;
  font-size: 16px;
  line-height: 1.55;
}

.featureItem:first-child {
  padding-top: 0;
}

.featureItem:last-child {
  border-bottom: none;
}

.featureLine {
  flex: 0 0 auto;
  width: 24px;
  height: 2px;
  margin-top: 10px;
  background: #00aeef;
}


/* ========================================
   IMAGE / VIDEO
======================================== */

.imageCol {
  position: relative;
  padding: 30px 15px 30px 50px;
}

.imageWrap {
  position: relative;
}

.featureImage,
.featureVideo {
  position: relative;
  z-index: 2;
  width: 100%;
  display: block;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
}


/* ========================================
   IMAGE DECORATION
======================================== */

.imageWrap::before {
  content: "";
  position: absolute;
  top: -25px;
  right: -25px;
  width: 110px;
  height: 110px;
  background: #00aeef;
  opacity: 0.1;
  z-index: 1;
}

.imageAccent {
  position: absolute;
  left: -10px;
  bottom: -20px;
  width: 140px;
  height: 140px;
  border: 2px solid #00aeef;
  opacity: 0.25;
  z-index: 1;
}


/* ========================================
   DISK
======================================== */

.disk {
  margin-top: -100px;
  margin-bottom: -100px;
}


/* ========================================
   TABLET
======================================== */

@media only screen and (max-width: 1240px) {

  .centreSection {
    padding: 80px 0;
  }

  .contentCol {
    padding-right: 30px;
  }

  .imageCol {
    padding-left: 30px;
  }

  .featureTitle {
    font-size: 36px;
  }

  .disk {
    margin-top: 0;
    margin-bottom: 0;
  }
}


/* ========================================
   MOBILE
======================================== */

@media only screen and (max-width: 991px) {

  .centreSection {
    padding: 70px 0;
  }

  .imageCol {
    padding: 20px 15px 50px;
  }

  .contentCol {
    padding: 20px 15px;
  }

  .featureContent {
    max-width: none;
  }

  .featureTitle {
    font-size: 34px;
  }

  .imageAccent {
    left: 0;
  }
}


/* ========================================
   SMALL MOBILE
======================================== */

@media only screen and (max-width: 767px) {

  .centreSection {
    padding: 50px 0;
  }

  ::v-deep .container {
    padding: 0 20px;
  }

  .imageCol {
    padding: 10px 10px 45px;
  }

  .contentCol {
    padding: 10px;
  }

  .featureTitle {
    font-size: 30px;
  }

  .featureText {
    font-size: 16px;
    line-height: 1.7;
  }

  .featureSubtitle {
    font-size: 19px;
  }

  .featureItem {
    font-size: 15px;
    gap: 12px;
  }

  .imageWrap::before {
    top: -15px;
    right: -15px;
    width: 70px;
    height: 70px;
  }

  .imageAccent {
    left: -5px;
    bottom: -15px;
    width: 90px;
    height: 90px;
  }
}


/* ========================================
   VERY SMALL MOBILE
======================================== */

@media only screen and (max-width: 480px) {

  .centreSection {
    padding: 40px 0;
  }

  .featureTitle {
    font-size: 27px;
  }

  .eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  .titleLine {
    margin: 18px 0 20px;
  }

  .featureLine {
    width: 18px;
  }
}

</style>
```
